import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "\n            d-flex\n            flex-column flex-root\n            position-absolute\n            min-w-100 min-h-100\n        " }
const _hoisted_2 = { class: "\n                login-view\n                d-flex\n                flex-center flex-column flex-column-fluid\n                p-sm-10\n            " }
const _hoisted_3 = { class: "\n                    login-block\n                    w-lg-500px\n                    bg-white\n                    rounded\n                    p-10 p-lg-15\n                    mx-auto\n                    anime-slide-top#xsmall\n                " }
const _hoisted_4 = {
  class: "form w-100",
  id: "kt_login_signin_form"
}
const _hoisted_5 = { class: "text-center mb-10" }
const _hoisted_6 = { href: "https://multiorders.com" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 fs-1" }, "Choose app")
], -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", { class: "text-dark fs-2 mb-0 ms-4" }, " Use Multiorders Marketplace Sync ", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Or use the ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "link-primary" }, "Multiorders OMS", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, [
              _createElementVNode("img", {
                alt: "Logo",
                src: _ctx.originUrl + _ctx.logo,
                class: "h-30px h-md-40px logo"
              }, null, 8, _hoisted_7)
            ])
          ]),
          _hoisted_8,
          _createElementVNode("a", {
            class: "\n                            d-flex\n                            gap-7\n                            align-items-center\n                            form-control form-control-lg form-control-solid\n                        ",
            href: _ctx.moConnectURL
          }, [
            _createElementVNode("img", {
              alt: "Logo",
              src: _ctx.originUrl + _ctx.favicon,
              class: "h-30px h-md-40px logo"
            }, null, 8, _hoisted_10),
            _hoisted_11
          ], 8, _hoisted_9)
        ])
      ]),
      _createVNode(_component_router_link, {
        to: _ctx.loginURL,
        class: "\n                    mt-5\n                    mo-link-hovarable\n                    link-primary\n                    text-gray-400\n                    fw-bold\n                    fs-7\n                    btn-text-long\n                "
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _hoisted_13
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}